<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Jonathan Garrett is a high school teacher who lives in Brisbane, Australia, with his wife and five children. He has a Bachelor of Education, majoring in modern history, and has studied political history and the ramifications of totalitarianism. He currently teaches English, history and business at a local independent school.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4330a30e